import Action from '../../../decorators/Action';
import Observable from '../../../decorators/Observable';
import StoreFieldInSession from '../../../decorators/StoreFieldInSession';
import AbstractSessionModel from '../../../models/AbstractSessionModel';

export default class BusinessDescriptionWizardData extends AbstractSessionModel {
  @Observable()
  @StoreFieldInSession()
  public business_description = '';

  @Observable()
  @StoreFieldInSession()
  public business_founding_date = null;

  @Observable()
  @StoreFieldInSession()
  public business_employees = 0;

  @Observable()
  @StoreFieldInSession()
  public business_client_addressing = '';

  @Observable()
  @StoreFieldInSession()
  public business_about_yourself = '';

  @Observable()
  @StoreFieldInSession()
  public business_tone_of_voice = '';

  @Observable()
  @StoreFieldInSession()
  public business_url_facebook = '';

  @Observable()
  @StoreFieldInSession()
  public business_url_instagram = '';

  @Observable()
  @StoreFieldInSession()
  public business_url_pinterest = '';

  @Observable()
  @StoreFieldInSession()
  public business_url_linkedin = '';

  @Observable()
  @StoreFieldInSession()
  public business_url_tiktok = '';

  @Observable()
  @StoreFieldInSession()
  public business_url_x = '';

  @Observable()
  @StoreFieldInSession()
  public business_url_xing = '';

  @Observable()
  @StoreFieldInSession()
  public business_url_youtube = '';

  constructor() {
    super();
    super.initFields();
  }

  @Action()
  setFormData(formData: {
    business_description: string;
    business_founding_date?: string;
    business_employees?: number;
    business_client_addressing?: string;
    business_about_yourself?: string;
    business_tone_of_voice?: string;
    business_url_facebook?: string;
    business_url_instagram?: string;
    business_url_pinterest?: string;
    business_url_linkedin?: string;
    business_url_tiktok?: string;
    business_url_x?: string;
    business_url_xing?: string;
    business_url_youtube?: string;
  }) {
    this.business_description = formData.business_description;
    this.business_founding_date = formData.business_founding_date;
    this.business_employees = formData.business_employees;
    this.business_client_addressing = formData.business_client_addressing;
    this.business_about_yourself = formData.business_about_yourself;
    this.business_tone_of_voice = formData.business_tone_of_voice;
    this.business_url_facebook = formData.business_url_facebook;
    this.business_url_instagram = formData.business_url_instagram;
    this.business_url_pinterest = formData.business_url_pinterest;
    this.business_url_linkedin = formData.business_url_linkedin;
    this.business_url_tiktok = formData.business_url_tiktok;
    this.business_url_x = formData.business_url_x;
    this.business_url_xing = formData.business_url_xing;
    this.business_url_youtube = formData.business_url_youtube;
  }

  getWizardData() {
    return {
      business_description: this.business_description,
      business_founding_date: this.business_founding_date,
      business_employees: this.business_employees,
      business_client_addressing: this.business_client_addressing,
      business_about_yourself: this.business_about_yourself,
      business_tone_of_voice: this.business_tone_of_voice,
      business_url_facebook: this.business_url_facebook,
      business_url_instagram: this.business_url_instagram,
      business_url_pinterest: this.business_url_pinterest,
      business_url_linkedin: this.business_url_linkedin,
      business_url_tiktok: this.business_url_tiktok,
      business_url_x: this.business_url_x,
      business_url_xing: this.business_url_xing,
      business_url_youtube: this.business_url_youtube
    };
  }

  public getSessionKey() {
    return 'BusinessDescriptionWizardData';
  }
}
